export default __webpack_public_path__ + "static/media/poster-background.74d1dcd5.png";